module.exports = __webpack_public_path__ + "img/fault_in_care.62a515b0.svg";